<template>
  <b-card :class="['presales-progress-card', 'border-0', 'shadow-sm', cardBgClass, { 'cursor-pointer': clickable }]" no-body @click="handleClick">
    <b-card-body>
      <h6 class="card-title text-white mb-2">{{ title }}</h6>
      <div class="d-flex justify-content-between align-items-center">
        <span class="display-6 text-white">{{ value }}</span>
        <i v-if="progressPercentage !== null" :class="progressIconClass" class="bi text-white"></i>
      </div>
      <div class="small mt-1" v-if="progressPercentage !== null">
        <span :class="progressTextClass">{{ formattedProgress }}%</span>
        <span class="text-white"> achieved</span>
      </div>
      <div class="small mt-1 text-white" v-if="subtitle">
        {{ subtitle }}
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';

export default {
  name: 'PresalesProgressCard',
  components: {
    BCard,
    BCardBody,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    progressPercentage: {
      type: [Number, null],
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardBgClass() {
      const map = {
        'light-blue darken-1': 'bg-info',
        'teal darken-1': 'bg-primary',
        'amber darken-1': 'bg-warning',
        'deep-orange darken-1': 'bg-danger',
        primary: 'bg-primary',
        info: 'bg-info',
        warning: 'bg-warning',
        danger: 'bg-danger',
      };
      return map[this.color] || 'bg-primary';
    },
    progressIconClass() {
      if (this.progressPercentage === null) return '';
      return this.progressPercentage >= 0 ? 'bi-graph-up-arrow' : 'bi-graph-down-arrow';
    },
    progressTextClass() {
      if (this.progressPercentage === null) return '';
      return this.progressPercentage >= 0 ? 'text-success' : 'text-danger';
    },
    formattedProgress() {
      if (this.progressPercentage === null) return Math.abs(this.progressPercentage).toFixed(2);
    },
  },
  methods: {
    handleClick() {
      if (this.clickable) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style scoped>
.presales-progress-card {
  margin: 10px;
}
</style>
